import * as constants from "./actions";
import axios from "@/plugins/axios.js";

function getDefaultState() {
  return {
    driversPrice: {
      status: null,
      data: [],
      error: null,
    },
    driverPrice: {
      status: null,
      data: {},
      error: null,
    },
  };
}

const actions = {
  [constants.GET_DRIVER_PRICE]: async ({ commit }, payload) => {
    try {
      commit(constants.GET_DRIVER_PRICE);

      const response = await axios.get("transfer/getDriverPrice", {
        params: payload,
      });
      commit(constants.GET_DRIVER_PRICE_SUCCESS, response);
      return response;
    } catch (error) {
      commit(constants.GET_DRIVER_PRICE_ERROR, error);
      throw error.response;
    }
  },
  [constants.POST_DRIVER_PRICE]: async ({ commit }, payload) => {
    try {
      commit(constants.POST_DRIVER_PRICE);
      const response = await axios.post("transfer/createAndUpdateDriverPrice", payload);
      commit(constants.POST_DRIVER_PRICE_SUCCESS, response);
      return response;
    } catch (error) {
      commit(constants.POST_DRIVER_PRICE_ERROR, error);
      throw error.response;
    }
  },
  [constants.DELETE_DRIVER_PRICE]: async ({ commit }, payload) => {
    try {
      commit(constants.DELETE_DRIVER_PRICE);
      const response = await axios.delete("transfer/deleteDriverPrice", {
        params: payload,
      });
      commit(constants.DELETE_DRIVER_PRICE_SUCCESS, response);
      return response;
    } catch (error) {
      commit(constants.DELETE_DRIVER_PRICE_ERROR, error);
      throw error.response;
    }
  }

};

const mutations = {
  [constants.GET_DRIVER_PRICE]: (state) => {
    state.driversPrice.status = "fetching";
    state.driversPrice.error = null;
  },
  [constants.GET_DRIVER_PRICE_SUCCESS]: (state, data) => {
    state.driversPrice.status = "success";
    state.driversPrice.error = null;
    state.driversPrice.data = data;
  },
  [constants.GET_DRIVER_PRICE_ERROR]: (state, error) => {
    state.driversPrice.status = "error";
    state.driversPrice.error = error;
  },
  [constants.POST_DRIVER_PRICE]: (state) => {
    state.driverPrice.status = "fetching";
    state.driverPrice.error = null;
  },
  [constants.POST_DRIVER_PRICE_SUCCESS]: (state, data) => {
    state.driverPrice.status = "success";
    state.driverPrice.error = null;
    state.driverPrice.data = data;
  },
  [constants.POST_DRIVER_PRICE_ERROR]: (state, error) => {
    state.driverPrice.status = "error";
    state.driverPrice.error = error;
  },
  [constants.DELETE_DRIVER_PRICE]: (state) => {
    state.driverPrice.status = "fetching";
    state.driverPrice.error = null;
  },
  [constants.DELETE_DRIVER_PRICE_SUCCESS]: (state, data) => {
    state.driverPrice.status = "success";
    state.driverPrice.error = null;
    state.driverPrice.data = data;
  },
  [constants.DELETE_DRIVER_PRICE_ERROR]: (state, error) => {
    state.driverPrice.status = "error";
    state.driverPrice.error = error;
  }
};


export default {
  state: getDefaultState(),
  actions,
  mutations
}